import { gql } from "@apollo/client";

export const ADD_ZIPCODE_GEOFENCE = gql`
    mutation AddZipcodeGeofence($geofence: ZipcodeMapGeofenceInput!) {
        addZipcodeGeofence(geofence: $geofence)
    }
`;

export interface ZipcodeMapGeofenceInput {
    zipcode: string;
    geometryType: string;
    boundary: string;
    notes?: string | null;
    status: string;
    descriptionType: string;
    descriptionOther?: string | null;
    creatorId: number;
    geofenceName: string;
    geofenceType: string;
}

export interface AddZipcodeGeofenceResponse {
    addZipcodeGeofence: boolean;
}
